import {postMethod} from '~/api'

async function post(hotelId) {
    return await postMethod(`/api/copyHotelInfo/${hotelId}`)
}

export {post}
